export default "__VITE_ASSET__Bq79ezDR__"